export default __webpack_public_path__ + "static/media/Colour_Design_-_adamr.space___Codecademy.dc426c77.pdf";